import Tooltip from "../../../Components/Tooltip";

export const formWrapperStyle = "flex w-full rounded-md border-[1px] border-text/30 p-5";

export const formContainerStyle = "flex flex-col w-full pr-5 h-[calc(var(--contentHeight))] overflow-y-auto mb-5"

export const detailsContentWrapperStyle = "text-text relative flex flex-col h-full items-center px-14 w-[-webkit-fill-available]";

export const DetailsContentHeader = (
  {
    label,
    tooltip,
    level,
  }
  :
  {
    label: string,
    tooltip?: string, 
    level?: "h2" | "h3" | "h4", // default is "h1" basically
  }
) => {
  let containerStyle = "mb-5";
  let labelStyle = "text-3xl";

  switch(level) {
    case "h2":
      containerStyle = "mb-2"
      labelStyle = "text-2xl"
      break;
  }

  return (
    <div className={`flex ${containerStyle} self-baseline`}>
      <h1 className={`font-bold ${labelStyle}`}>{label}</h1>
      {tooltip && <Tooltip content={tooltip}/>}
    </div>
  )
};